import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import website from '@/components/website'
import halababy from '@/components/halababy'
import looplay from '@/components/looplay'
import about from '@/components/about'
import brand from '@/components/brand'
import newDetail from '@/components/newDetail'
import search from '@/components/search'
import gameDetailPage from '@/components/gameDetailPage'
import uoofox from '@/components/uoofox'
import privacyPolicy from '@/components/privacyPolicy'
import protocol from '@/components/protocol'
import copyright from '@/components/copyright'

import bind from '@/components/spreader/bind'
import spreaderLogin from '@/components/spreader/login'
import spreaderIndex from '@/components/spreader/index'
import spreaderHome from '@/components/spreader/home'
import withdraw from '@/components/spreader/withdraw'
import personalData from '@/components/spreader/personalData'
import wxlogin from '@/components/spreader/wxlogin'
import leaveWords from '@/components/leaveWords/leaveWords'
import download from '@/components/download/download'
import convert from '@/components/vip/convert'

Vue.use(Router)

//解决 Avoided redundant navigation to current location: "/search".
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/spreader/bind',
      component: bind,
    },
    {
      path: '/vip/convert',
      component: convert,
    },
    {
      path: '/dl/app',
      component: download
    },
    {
      path: '/wx/leaveWords',
      component: leaveWords
    },
    {
      path: '/spreader/login',
      component: spreaderLogin
    },
    {
      path:'/spreader/wxlogin',
      component: wxlogin,
    },
    {
      path: '/spreader',
      component: spreaderIndex,
      children:[
        {
          path:'',
          component: spreaderHome,
        },
        {
          path:'home',
          component: spreaderHome,
        },
        {
          path:'withdraw',
          component: withdraw,
        },
        {
          path:'personalData',
          component: personalData,
        },
      ]
    },
    {
      path: '/',
      component: website,
      children: [
        {
          path: '',
          component: index,
        },
        {
          path: 'index',
          component: index,
        },
        {
          path: 'halababy',
          component: halababy
        },
        {
          path: 'looplay',
          component: looplay
        }
        ,
        {
          path: 'about',
          component: about
        }
        ,
        {
          path: 'brand',
          component: brand
        },
        {
          path: 'newDetail/:id',
          component: newDetail
        },
        {
          path: 'search',
          component: search
        },
        {
          path: 'gameDetailPage/:id',
          component: gameDetailPage,
        },
        {
          path: 'uoofox',
          component: uoofox,
        }
        ,
        {
          path: 'privacyPolicy',
          component: privacyPolicy,
        },
        {
          path: '/app/treaty/index.html',
          component: privacyPolicy,
        },
        {
          path: 'protocol',
          component: protocol,
        },
        {
          path: '/app/treaty/installation.html',
          component: protocol,
        },
        {
          path: 'copyright',
          component: copyright,
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js